import { apiFetch } from "../helper/apiClient";

export const logItemSelect = (productId, searchQuery, searchEventId = null) => {
  const payload = {
    product_id: productId,
    search_query: searchQuery || "",
  };
  if (searchEventId != null) {
    payload.search_event_id = searchEventId;
  }

  apiFetch("events/item-select", {
    method: "POST",
    body: JSON.stringify(payload),
  }, { auth: true }).catch(() => {}); // fail silently
};